export const supportedTypes = `.JPG , .JPEG , .PNG , .GIF , .SVG ,
.PSD , .DXF , .AI , .SKETCH , .HEIC , .DWG , .INDD , .FLA , .EPS , .XCF , .CDR , .ODG ,
.MP3 , .WAV , .FLAC , .M4A , .m4p , .MP4 , .AVI , .MOV , .XVID , .MKV ,
.OGV , .VOB , .3GP , .MPG , .MPE , .MPEG , .divx , .GPX , .XYZ , .EXE , .TTF ,
.OTF , .WEB , .WOFF2 , .WOFF , .ZIP , .RAR , .GZIP , .TAR , .GZ ,
.XLS , .XLSX , .XLSM , .XLT , .XLTX , .CSV , .ODS , .OTS ,
.DOC , .DOCX , .DOCB , .DOT , .DOTX , .ODT , .OTT , .XPS , .OXPS , .PUB , .TXT , .RTF , .JSON ,
.ODP , .OTP , .PPS , .PPSX , .PPT , .PPTX , .POT , .POTX ,
.PDF , .KEY , .NUMBERS , .PAGES , .KML , .KMZ ,
.VCF , .ICS , .ICAL , .ICALENDAR , .IFB , .EPUB , .MOBI , .IPYNB`;
